invHdApp.controller('CustomerNewOrderController',
    ['$scope', '$location', '$rootScope', 'User', '$timeout', 'Order', 'CustomerOrder', 'FileUploader', '$filter', '$http', '$routeParams',
        function($scope, $location, $rootScope, User, $timeout, Order, CustomerOrder, FileUploader, $filter, $http, $routeParams) {
            $rootScope.proccesCount = 1;
            
            $scope.newOrderData = {
                type: 1,
                address: {},
                scheduled_time: '',
                status: 2,
                location: {},
                order_payment: 'offline',
                flexible_date : 0,
                items : [{
                    weight : null,
                }]
            };

            $scope.startMarker = null;
            $scope.endMarker = null;

            var componentForm = {
                street_number: 'short_name',
                route: 'long_name',
                locality: 'long_name',
                administrative_area_level_1: 'short_name',
                administrative_area_level_2: 'short_name',
                country: 'long_name',
                postal_code: 'short_name'
            };

            var mapping = {
                street_number: 'number',
                route: 'street',
                locality: 'city',
                administrative_area_level_1: 'state',
                administrative_area_level_2: 'district',
                country: 'country',
                postal_code: 'zip'
            };

            $scope.init = function() {
                CustomerOrder.newOrderData().success(function(data) {
                    $scope.orderData = data;
                    $scope.newOrderData = {
                        type: 1,
                        address: {},
                        scheduled_time: '',
                        status: 2,
                        location: {},
                        order_payment: 'offline',
                        flexible_date : 0,
                        items : [{
                            weight : null,
                        }],
                        work_type : $scope.orderData.workTypes[0].id
                    };
                    createMapCustomer()
                });
                if($routeParams.order_id) {
                    Order.order($routeParams.order_id).success(function (data, status, headers, config) {
                        $scope.newOrderData = data.order
                        $scope.newOrderData.work_type = data.order.work_type ? data.order.work_type.id : $scope.orderData.workTypes[0].id;
                        $scope.locationSelectedCustomer(data.order.location, 'order')
                    });
                }
            }

            $scope.submitNewOrder = function() {
                if(!$scope.newOrderData.location.name) {
                    $('.location-name input').focus();
                }else {
                    setTimeout(() => {
                        document.getElementById('newWorkBtn').click()
                    }, 300);
                }
            }

            $scope.addBox = function() {
                // Düzenlemede newOrderData tamamen sunucu yanıtıyla değiştiriliyor; paketi
                // olmayan işlerde items alanı hiç gelmeyebiliyor.
                if (!$scope.newOrderData.items) {
                    $scope.newOrderData.items = [];
                }
                $scope.newOrderData.items.push({
                    weight : null,
                });
            }

            $scope.removeBox = function(index) {
                $scope.newOrderData.items.splice(index, 1);
            }

            $scope.newCustomerOrder = function(newWork) {
                if (newWork) {
                    $scope.disabledBtn = true;
                    CustomerOrder.newCustomerOrder($scope.newOrderData).success(function(data, status, headers, config) {
                        $scope.newOrderData = {
                            type: 1,
                            address: {},
                            scheduled_time: '',
                            status: 2,
                            location: {},
                            order_payment: 'offline',
                            flexible_date : 0,
                            items : [{
                                weight : null,
                            }]
                        };
                        $scope.disabledBtn = false;
                        $('#successBox').modal('show');
                        // $scope.getOrderDetails(data);

                    }).error(function(data) {
                        Messenger().post({message: data.message,type: "error"});
                        $scope.disabledBtn = false;
                    });
                }
            }

            $scope.updateOrder = function (newWork) {
                $scope.disabledBtn = true;
                CustomerOrder.updateCustomerOrder($scope.newOrderData).success(function (data, status, headers, config) {
                    Messenger().post('Başarıyla Güncellendi!');
                    $scope.disabledBtn = false;
                    $('#successBox').modal('show');
                    $scope.newOrderData = {
                        type: 1,
                        address: {},
                        scheduled_time: '',
                        status: 2,
                        location: {},
                        order_payment: 'offline',
                        flexible_date : 0,
                        items : [{
                            weight : null,
                        }]
                    };
                    $rootScope.procces = 'update';
                }).error(function (data) {
                    $scope.disabledBtn = false;
                    Messenger().post({message: data.message,type: "error"});
                });
            };

            $scope.locationSelectedCustomer = function(selected, type) {
                if (typeof type === 'undefined') {
                    if (typeof selected !== 'undefined') {
                        var customer = selected.originalObject;
                    } else {
                        var customer = [];
                    }
                } else {
                    var customer = selected;
                }
                if (typeof customer !== 'undefined' && typeof customer.latitude !== 'undefined') {
                    var location = new google.maps.LatLng(customer.latitude, customer.longitude);
                    setTimeout(function() {
                        $scope.searchMap.setCenter(location);
                        $scope.marker.setDuration(1000);
                        $scope.marker.setEasing("swing");
                        $scope.marker.setPosition(location);
                        angular.merge($scope.newOrderData.location, customer);
                        $scope.newOrderData.location.city = customer.city;
                        $scope.newOrderData.location.state = customer.state;
                        if(type && type == 'search') {
                            var address = ''
                            if(customer.street) {
                                address += customer.street + ' '
                            }
                            if(customer.number) {
                                address += 'No:' + customer.number + ' '
                            }
                            $scope.newOrderData.location.address = address;
                        }else {
                            $scope.newOrderData.location.address = customer.address;
                        }
                        $scope.newOrderData.location.zipcode = customer.zipcode ? customer.zipcode : customer.zip;
                        $scope.states.forEach(element => {
                            if (element.abbreviation == customer.city) {
                                $scope.newOrderData.location.state = element.name;
                                return true;
                            }
                        });
                        $scope.$apply();
                    }, 300);
                }
            }

            function createMapCustomer() {
                var location = new google.maps.LatLng(Number($scope.authenticatedUser.location.lat), Number($scope.authenticatedUser.location.lon));
                setTimeout(function() {
                    $scope.searchMap = new google.maps.Map(document.getElementById('customerMapOrder'), {
                        zoom: 11,
                        center: location,
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                        disableDefaultUI: true,
                        styles: [{
                                "elementType": "geometry",
                                "stylers": [{
                                    "color": "#f5f5f5"
                                }]
                            },
                            {
                                "elementType": "labels.icon",
                                "stylers": [{
                                    "visibility": "off"
                                }]
                            },
                            {
                                "elementType": "labels.text.fill",
                                "stylers": [{
                                    "color": "#616161"
                                }]
                            },
                            {
                                "elementType": "labels.text.stroke",
                                "stylers": [{
                                    "color": "#f5f5f5"
                                }]
                            },
                            {
                                "featureType": "administrative.land_parcel",
                                "elementType": "labels.text.fill",
                                "stylers": [{
                                    "color": "#bdbdbd"
                                }]
                            },
                            {
                                "featureType": "landscape.natural",
                                "elementType": "geometry.stroke",
                                "stylers": [{
                                    "color": "#4247bd"
                                }]
                            },
                            {
                                "featureType": "poi",
                                "elementType": "geometry",
                                "stylers": [{
                                    "color": "#eeeeee"
                                }]
                            },
                            {
                                "featureType": "poi",
                                "elementType": "labels.text.fill",
                                "stylers": [{
                                    "color": "#757575"
                                }]
                            },
                            {
                                "featureType": "poi.business",
                                "stylers": [{
                                    "visibility": "off"
                                }]
                            },
                            {
                                "featureType": "poi.park",
                                "elementType": "geometry",
                                "stylers": [{
                                    "color": "#e5e5e5"
                                }]
                            },
                            {
                                "featureType": "poi.park",
                                "elementType": "labels.text",
                                "stylers": [{
                                    "visibility": "off"
                                }]
                            },
                            {
                                "featureType": "poi.park",
                                "elementType": "labels.text.fill",
                                "stylers": [{
                                    "color": "#9e9e9e"
                                }]
                            },
                            {
                                "featureType": "road",
                                "elementType": "geometry",
                                "stylers": [{
                                    "color": "#ffffff"
                                }]
                            },
                            {
                                "featureType": "road.arterial",
                                "elementType": "labels.text.fill",
                                "stylers": [{
                                    "color": "#757575"
                                }]
                            },
                            {
                                "featureType": "road.highway",
                                "elementType": "geometry",
                                "stylers": [{
                                    "color": "#dadada"
                                }]
                            },
                            {
                                "featureType": "road.highway",
                                "elementType": "labels.text.fill",
                                "stylers": [{
                                    "color": "#616161"
                                }]
                            },
                            {
                                "featureType": "road.local",
                                "elementType": "labels.text.fill",
                                "stylers": [{
                                    "color": "#9e9e9e"
                                }]
                            },
                            {
                                "featureType": "transit.line",
                                "elementType": "geometry",
                                "stylers": [{
                                    "color": "#e5e5e5"
                                }]
                            },
                            {
                                "featureType": "transit.station",
                                "elementType": "geometry",
                                "stylers": [{
                                    "color": "#eeeeee"
                                }]
                            },
                            {
                                "featureType": "water",
                                "elementType": "geometry",
                                "stylers": [{
                                    "color": "#c9c9c9"
                                }]
                            },
                            {
                                "featureType": "water",
                                "elementType": "geometry.fill",
                                "stylers": [{
                                    "color": "#bdd1e8"
                                }]
                            },
                            {
                                "featureType": "water",
                                "elementType": "labels.text.fill",
                                "stylers": [{
                                    "color": "#9e9e9e"
                                }]
                            }
                        ]
                    });

                    $scope.marker = new SlidingMarker({
                        position: location,
                        map: $scope.searchMap,
                        visible: true,
                        draggable: true,
                        icon: '/img/map-pin.png'
                    });


                    if (navigator.geolocation && !$scope.newOrderData.id) {
                        navigator.geolocation.getCurrentPosition(function(position) {
                            var location = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                            $scope.marker.setPosition(location)
                            $scope.searchMap.setCenter(location)
                        });
                    } else {
                        console.log("Geolocation is not supported by this browser.");
                    }

                    var input = document.getElementById('googlePlaceInput');
                    google.maps.event.addDomListener(input, 'keydown', function(e) {
                        if (e.keyCode == 13) {
                            e.preventDefault();
                        }
                    });

                    $scope.marker.addListener('dragend', function(event) {

                        var latlng = new google.maps.LatLng(event.latLng.lat(), event.latLng.lng());
                        var geocoder = new google.maps.Geocoder();

                        geocoder.geocode({ 'latLng': latlng }, function(results, status) {
                            if (status === google.maps.GeocoderStatus.OK) {
                                if (results[0]) {
                                    var place = results[0];
                                    var details = place.geometry && place.geometry.location ? {
                                        latitude: place.geometry.location.lat(),
                                        longitude: place.geometry.location.lng()
                                    } : {};
                                    for (var i = 0; i < place.address_components.length; i++) {
                                        var addressType = place.address_components[i].types[0];
                                        if (componentForm[addressType]) {
                                            var val = place.address_components[i][componentForm[addressType]];
                                            details[mapping[addressType]] = val;
                                        }
                                    }
                                    details.formatted = place.formatted_address;
                                    details.placeId = place.place_id;
                                    details.address = place.formatted_address;
                                    angular.merge($scope.newOrderData.location, details);
                                    $scope.newOrderData.location.city = details.state;
                                    $scope.newOrderData.location.state = details.district;
                                    var address = ''
                                    if(details.street) {
                                        address += details.street + ' '
                                    }
                                    if(details.number) {
                                        address += 'No:' + details.number + ' '
                                    }
                                    $scope.newOrderData.location.address = address;
                                    $scope.newOrderData.location.zipcode = details.zipcode ? details.zipcode : details.zip;
                                    $scope.$apply();
                                }
                            }
                        });
                    });
                }, 300);


            }
        }
    ]);